import { ScheduleState } from "../../../type/schedule-state";

interface Action {
  type: string;
  payload: {
    selectedClientIds: string;
  };
}

export const setSelectedClientIdsDispatch = (
  state: ScheduleState,
  action: Action
) => {
  const { selectedClientIds } = action.payload;

  if (state.selectedClientIds.includes(selectedClientIds)) {
    state.selectedClientIds = state.selectedClientIds.filter(
      (v) => v !== selectedClientIds
    );
  } else {
    state.selectedClientIds = [...state.selectedClientIds, selectedClientIds];
  }
};
